import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class TransitionAnimation extends Container{
  constructor(data) {
    super()
    this._data = data
    this.spine = new Spine(create(data, data.spine))
    this.spine.scale.set(data.scale ? data.scale : 1)
    this.addChild( this.spine)
    this.createSignal()

  }
  createSignal() {
    signal.on('TRANSITION-BONUS-ANIM', this.animate.bind(this))
  }

  async animate() {
    this.spine.stop()
    this.spine.setToSetupPose()
    await this.spine.play(this._data.animation, false)

    signal.dispatch('TRANSITION-BONUS-ANIM:DONE')
  }
}
